<template>
  <div>
    <hr class="mt-0" />
    <div class="mb-3">
      <div class="display-4 font-3xl">
        <b-row class="pr-3">
          <b-col>
            {{ `Select a ${selected_process_type} process` }}
          </b-col>
          <b-col v-if="valid_process_list.length" cols="2" class="px-0">
            <b-button variant="success" block @click="handleToggleAllClick">
              <i :class="is_all_checked ? 'fa fa-check-square' : 'fa fa-square'" />
              Toggle All
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <template v-if="valid_process_list.length">
      <b-row class="pr-3">
        <schedule-select-button v-for="(process, index) in valid_process_list" :key="index" :item="process" :isActive="!!(
            selected_processes &&
            selected_processes.find(
              (selected_process) => selected_process.process.id === process.id
            )
          )
          " :label="process.name" icon="flask" @onClick="handleFormUpdate" />
      </b-row>
    </template>
    <div v-else>
      <b-alert show class="mb-4">No processes are available.</b-alert>
    </div>
  </div>
</template>

<script>
import ScheduleSelectButton from "./ScheduleSelectButton";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProcessSelector",
  components: { ScheduleSelectButton },
  props: {
    context_process_list: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    ...mapGetters({ schedule_form: "scheduleForm" }),
    selected_sample_type_id() {
      return this.schedule_form.sample_type_id;
    },
    current_process_list() {
      return this.context_process_list.models.filter((process) => {
        return process.sample_type_id === this.selected_sample_type_id;
      });
    },
    selected_processes() {
      return this.schedule_form.processes;
    },
    selected_process_type() {
      return this.schedule_form.process_type;
    },
    is_all_checked() {
      return (
        this.valid_process_list.length ===
        this.selected_processes.length
      );
    },
    valid_process_list() {
      const process_type = this.selected_process_type === 'Testing' ? 'test' : 'prep';
      return this.context_process_list.models.filter((process) => {
        let updateProcess = null;
        if (process.attributes[`${process_type}_tasks`].length) {

          process.attributes[`${process_type}_tasks`].forEach((task) => {
            // check for attached insturments OR inspecific scheduling designation
            if (task.inspecific_scheduling || task.instrument_instances.length) {
              updateProcess = process;
            }
          });
        }
        return updateProcess;
      })
    }
  },
  methods: {
    ...mapActions(["UPDATE_SCHEDULE_FORM"]),
    handleFormUpdate(process) {
      let processes_update = [...this.selected_processes];

      if (
        processes_update.find(
          (selected_process) => selected_process.process.id === process.id
        )
      ) {
        processes_update = this.selected_processes.filter(
          (selected_process) => selected_process.process.id !== process.id
        );
      } else {
        processes_update = [
          ...this.selected_processes,
          {
            process,
            instruments:
              this.selected_process_type === "Testing"
                ? []
                : [],
          },
        ];
      }
      this.UPDATE_SCHEDULE_FORM({
        field: "processes",
        value: processes_update,
      });
    },
    handleToggleAllClick() {
      let update = [];
      !this.is_all_checked &&
        this.valid_process_list.forEach(process => {
          update = [
            ...update,
            {
              process,
              instruments:
                this.selected_process_type === "Testing"
                  ? []
                  : [],
            },
          ];
        });
      this.UPDATE_SCHEDULE_FORM({ field: "processes", value: update });
    },
  },
};
</script>
